import { ModalShell } from './ModalShell.js';
import { pillButton } from './pillButton.js';

import type { ReactElement } from 'react';

type EndPartyConfirmModalProps = {
  readonly partyDisplayName: string;
  readonly isPending: boolean;
  readonly onConfirm: () => void;
  readonly onCancel: () => void;
};

export const EndPartyConfirmModal = ({
  partyDisplayName,
  isPending,
  onConfirm,
  onCancel,
}: EndPartyConfirmModalProps): ReactElement => (
  <ModalShell title={`End ${partyDisplayName}?`} onDismiss={onCancel}>
    <p className="text-secondary mt-2 text-sm">
      Every other DJ is cut off mid-set: their console stops following Spotify, and so does the
      projector view. Nobody can undo this — a channel can be taken again afterwards, but this party
      is done.
    </p>
    <div className="mt-4 flex gap-2">
      <button
        type="button"
        disabled={isPending}
        onClick={onConfirm}
        className={`${pillButton('danger')} flex-1`}
      >
        Yes, end it for everyone
      </button>
      <button type="button" onClick={onCancel} className={pillButton('ghost')}>
        No, keep going
      </button>
    </div>
  </ModalShell>
);
